module.exports = __webpack_public_path__ + "static/img/abotu-bottom-img.5b03218.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/abotu-bottom-img.png
// module id = U7LD
// module chunks = 1